import { defineComponent as _defineComponent } from 'vue'
import BuilderEstimatorSummaryItemWithImage from "./BuilderEstimatorSummaryItemWithImage.vue";
  import BuilderEstimatorSummaryItemWithoutImage from "./BuilderEstimatorSummaryItemWithoutImage.vue";
  import type { OptionalUpgrade } from "@/types/OptionalUpgradeInterface";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderEstimatorSummaryItem',
  props: {
    title: {},
    value: {},
    price: {},
    imageUrl: {},
    isMobile: { type: Boolean }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

  

const __returned__ = { BuilderEstimatorSummaryItemWithImage, BuilderEstimatorSummaryItemWithoutImage }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})